export default __webpack_public_path__ + "static/media/EVZ5_white_background_and_circuit.78d23686.png";